import { useState } from "react";
import { EnergyLabelDrawer } from "./EnergyLabelDrawer/EnergyLabelDrawer";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { EnergyRating } from "@JohnLewisPartnership/jl-design-system/dist/components/energy-rating/EnergyRating";
import { ChevronRightOutlined as ChevronRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import classnames from "classnames/bind";
import styles from "./EnergyLabel.module.scss";

const cx = classnames.bind(styles);

export type EnergyLabelProps = {
  /**
   * An optional string representing the information sheet.
   */
  informationSheet?: string;
  /**
   * A boolean indicating whether the energy label is legacy.
   */
  isLegacy: boolean;
  /**
   * An optional string representing the label.
   */
  label?: string;
  /**
   * A string representing the rating.
   */
  rating: string;
  /**
   * An optional string representing the open drawer event.
   */
  openDrawerEvent?: string;
  /**
   * An optional string representing the close drawer event.
   */
  closeDrawerEvent?: string;
};

const availableRating = ["A", "B", "C", "D", "E", "F", "G"];
const availableRatingLegacy = ["A+++", "A++", "A+", "A", "B", "C", "D"];

export function EnergyLabel({
  label,
  rating,
  informationSheet,
  isLegacy,
  openDrawerEvent,
  closeDrawerEvent,
}: EnergyLabelProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenDrawer = () => {
    if (openDrawerEvent) {
      dispatchMonetateQEvent(openDrawerEvent);
    }

    setIsOpen(true);
  };

  const handleCloseDrawer = () => {
    if (closeDrawerEvent) {
      dispatchMonetateQEvent(closeDrawerEvent);
    }

    setIsOpen(false);
  };

  const isEnergyRatingValid =
    (isLegacy && availableRatingLegacy.includes(rating)) ||
    (!isLegacy && availableRating.includes(rating));

  if (!rating || !isEnergyRatingValid) {
    return null;
  }

  const hasAdditionalSheets = !!label || !!informationSheet;

  return (
    <>
      <button
        className={cx("energyLabelItem", "premiumStyle")}
        onClick={hasAdditionalSheets ? handleOpenDrawer : undefined}
      >
        <EnergyRating
          rating={isLegacy ? undefined : rating}
          ratingLegacy={isLegacy ? rating : undefined}
          className={styles.energyLabelIcon}
        />
        <span className={cx("energyRatingText")}>Energy rating</span>
        <ChevronRight size="medium" />
      </button>
      {hasAdditionalSheets && (
        <EnergyLabelDrawer
          isOpen={isOpen}
          isLegacy={isLegacy}
          handleClose={handleCloseDrawer}
          rating={rating}
          label={label}
          informationSheet={informationSheet}
        />
      )}
    </>
  );
}
